import React from 'react';

interface State { error: Error | null }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: '40px 24px', color: '#ef4444', fontFamily: 'monospace', fontSize: '13px' }}>
          <strong style={{ fontSize: '16px', display: 'block', marginBottom: '12px' }}>
            Something went wrong
          </strong>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#8a93b0' }}>
            {this.state.error.message}
            {'\n\n'}
            {this.state.error.stack}
          </pre>
          <button
            style={{ marginTop: '16px', padding: '8px 16px', background: '#ef444420', border: '1px solid #ef4444', borderRadius: '6px', color: '#ef4444', cursor: 'pointer', fontSize: '13px' }}
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
